import React from 'react'

import { mainColors } from '../styles'

export const NoValue = () => <span style={{ color: mainColors.neutralDark }}>–</span>
